import excellence from './excellence'
import voucher from './voucher'
import msg from './msg'

const base = {
  BASE_URL: 'psm/qc/',
  api: [{
      name: 'record-detail',
      desc: '获取申报表单明细',
      method: 'GET',
      path: '/yxqcxz/query'
    },
    {
      name: 'config-update',
      desc: '更新系统配置',
      method: 'POST',
      path: '/config/update'
    },
    {
      name: 'config-query',
      desc: '查询系统配置',
      method: 'GET',
      path: '/config/query'
    }
  ]
}

export default {
  excellence,
  base,
  voucher,
  msg
}



// WEBPACK FOOTER //
// ./src/api/psm/qc/index.js